import React from "react";

const SimpleBackgroundTest = () => {
  return (
    <div className="min-h-screen bg-[#FFF8E1] relative">
      {/* Simple test background */}
      <div 
        className="fixed inset-0 -z-10"
        style={{
          background: "radial-gradient(circle at 50% 50%, rgba(255, 193, 7, 0.3), transparent 70%)",
          opacity: 0.8
        }}
      />
      
      <div className="relative z-10 p-8">
        <h1 className="text-4xl font-fredoka font-bold text-black mb-4">
          Simple Background Test
        </h1>
        <p className="text-lg font-baloo text-black mb-4">
          This should show a simple amber gradient background.
        </p>
        
        <div className="bg-white p-4 rounded-xl shadow-lg">
          <h2 className="text-xl font-fredoka font-bold text-black">White Card</h2>
          <p className="text-gray-700 font-baloo">This should be clearly visible over the background.</p>
        </div>
      </div>
    </div>
  );
};

export default SimpleBackgroundTest;



